module.exports = __webpack_public_path__ + "static/img/cjx10.324a5c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cjx10.png
// module id = 167
// module chunks = 0